import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from "react";
import removeMatchingPlugins from "./removeMatchingPlugins";
export var overloadTailwind = function overloadTailwind(initialClasses, overloadClasses) {
  if (!overloadClasses) {
    return initialClasses;
  }

  var removed = removeMatchingPlugins(initialClasses, overloadClasses);
  return (removed + " " + overloadClasses).trim();
};

var withTailwindOverload = function withTailwindOverload(PassedComponent) {
  return function (_ref) {
    var className = _ref.className,
        rest = _objectWithoutProperties(_ref, ["className"]);

    if (!PassedComponent.defaultClassName) {
      throw new Error("No defaultClassName found. Components wrapped withTailwindOverload() require defaultClassName property 'MyComponent.defaultClassname = \"text-gray-500\"'");
    }

    var overloadedClasses = overloadTailwind(PassedComponent.defaultClassName, className);
    return React.createElement(PassedComponent, _extends({}, rest, {
      className: overloadedClasses
    }));
  };
};

export { withTailwindOverload };